import { useState } from "react";

import { ky302 } from "../libs/ky";

const useImageUpload = () => {
  const [loading, setLoading] = useState(false);
  const upload = async (file: File) => {
    setLoading(true);
    let result: string | null = null;
    const url = `gpt/api/upload/gpt/image`;
    const form = new FormData();
    form.append("file", file);
    try {
      const res = await ky302
        .post(url, {
          body: form,
        })
        .json<{ data: { url: string } }>();
      result = res.data.url;
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
    return result;
  };

  return {
    loading,
    upload,
  };
};
export default useImageUpload;
